<template>
  <div class="pages">
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="待审核" name="0">
        <div class="filter">
          <div>
            <el-form size="small" :inline="true">
              <!-- <el-form-item label="标签">
                <el-select v-model="formInline.user">
                  <el-option label="全部" value=""></el-option>
                  <el-option label="企业招聘" value="0"></el-option>
                  <el-option label="生活" value="1"></el-option>
                  <el-option label="租房" value="2"></el-option>
                  <el-option label="找工作" value="3"></el-option>
                  <el-option label="其他" value="4"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="角色">
                <el-select v-model="formInline.user">
                  <el-option label="全部" value=""></el-option>
                  <el-option label="生活" value="1"></el-option>
                  <el-option label="租房" value="2"></el-option>
                  <el-option label="找工作" value="3"></el-option>
                  <el-option label="其他" value="4"></el-option>
                </el-select>
              </el-form-item> -->
              <el-form-item label="提交日期">
                <el-date-picker
                  v-model="formInline.dataValue"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                >
                </el-date-picker>
              </el-form-item>
            </el-form>
          </div>
          <div class="search">
            <el-form size="small" :inline="true">
              <el-form-item label="关键字">
                <el-input
                  v-model="formInline.keyWord"
                  placeholder="请输入关键词查询"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="searcList">搜索</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="历史记录" name="1">
        <div class="filter">
          <div>
            <el-form size="small" :inline="true">
              <!-- <el-form-item label="标签">
                <el-select v-model="formInline.user">
                  <el-option label="企业招聘" value="0"></el-option>
                  <el-option label="生活" value="1"></el-option>
                  <el-option label="租房" value="2"></el-option>
                  <el-option label="找工作" value="3"></el-option>
                  <el-option label="其他" value="4"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="角色">
                <el-select v-model="formInline.user">
                  <el-option label="生活" value="1"></el-option>
                  <el-option label="租房" value="2"></el-option>
                  <el-option label="找工作" value="3"></el-option>
                  <el-option label="其他" value="4"></el-option>
                </el-select>
              </el-form-item> -->
              <el-form-item label="提交日期">
                <el-date-picker
                  v-model="formInline.dataValue"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                >
                </el-date-picker>
              </el-form-item>
            </el-form>
          </div>
          <div class="search">
            <el-form size="small" :inline="true">
              <el-form-item label="关键字">
                <el-input
                  v-model="formInline.keyWord"
                  placeholder="请输入关键词查询"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="searcHistoryList"
                  >搜索</el-button
                >
              </el-form-item>
            </el-form>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>

    <div class="table">
      <div v-show="activeName == 0">
        <el-button type="primary" size="medium" @click="judStudents"
          >批量审核</el-button
        >
        <el-table
          :data="tableData"
          @selection-change="handleSelectionChange"
          height="4.92rem"
          max-height="4.92rem"
        >
          <el-table-column type="selection" align="center" width="50">
          </el-table-column>
          <el-table-column type="index" label="序号" align="center" width="50">
          </el-table-column>
          <el-table-column property="userName" label="用户名" align="center">
          </el-table-column>
          <el-table-column property="name" label="真实姓名" align="center">
          </el-table-column>
          <el-table-column
            property="schoolName"
            label="认证学校"
            align="center"
          >
          </el-table-column>
          <el-table-column
            property="createTime"
            label="提交时间"
            align="center"
          >
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button @click="see(scope.row)" type="text" size="medium"
                >审核</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div v-show="activeName == 1">
        <el-table :data="tableData" height="5.28rem" max-height="5.28rem">
          <el-table-column type="index" label="序号" align="center" width="50">
          </el-table-column>
          <el-table-column property="userName" label="用户名" align="center">
          </el-table-column>
          <el-table-column property="name" label="真实姓名" align="center">
          </el-table-column>
          <el-table-column
            property="schoolName"
            label="认证学校"
            align="center"
          >
          </el-table-column>
          <el-table-column
            property="createTime"
            label="提交时间"
            align="center"
          >
          </el-table-column>
          <el-table-column
            property="updateTime"
            label="审核时间"
            align="center"
          >
          </el-table-column>
          <el-table-column property="state" label="认证状态" align="center">
            <template slot-scope="scope">
              <p v-if="scope.row.state === 1" style="color: #2ee12e">已认证</p>
              <p v-else-if="scope.row.state === 2" style="color: #ea2727">
                未通过
              </p>
              <p v-else style="color: #ea2727; font-weight: bold">异常</p>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button @click="see(scope.row)" type="text" size="medium"
                >详情</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pages justify-end">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="currentSize"
          layout="  prev, pager, next,  sizes, jumper"
          :total="totalCount"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog
      title="查看"
      :visible.sync="centerDialogVisible"
      :destroy-on-close="true"
      width="60%"
      center
    >
      <Faculty :currTeacherInfo="currTeacherInfo"></Faculty>
      <span slot="footer" class="dialog-footer">
        <el-button v-if="activeName == 0" type="primary" @click="submit"
          >通 过</el-button
        >
        <el-button v-if="activeName == 0" type="danger" @click="reject"
          >驳 回</el-button
        >
        <el-button v-if="activeName == 1" @click="centerDialogVisible = false"
          >关 闭</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Faculty from "../../components/userDetail/Faculty.vue"; //教职工认证
export default {
  data() {
    return {
      centerDialogVisible: false,
      activeName: 0,
      tableData: [],
      //搜索信息
      formInline: {
        dataValue: "",
        keyWord: "",
      },
      //教师信息
      currTeacherInfo: [],
      //翻页
      currentPage: 1,
      currentSize: 10,
      totalCount: 0,
      //多选框
      multipleSelection: [],
      //批量审核id
      judIds: [],
    };
  },
  created() {
    this.getTeacherList();
  },
  mounted() {},
  methods: {
    reject() {
      this.$prompt("确认驳回申请?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /^.+$/,
        inputErrorMessage: "请填写理由",
      })
        .then(({ value }) => {
          this.adjustTeacher([this.currTeacherInfo[0].id], 2, value);
        })
        .catch(() => {});
    },
    submit() {
      console.log(this.currTeacherInfo);
      this.$confirm("确认通过审核?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.adjustTeacher([this.currTeacherInfo[0].id], 1);
        })
        .catch(() => {});
    },
    //选项卡切换
    handleSelectionChange(val) {
      this.judIds = [];
      this.multipleSelection = val;
      console.log(this.multipleSelection);
      this.multipleSelection.forEach((element) => {
        this.judIds.push(element.id);
      });
      console.log(this.judIds);
    },
    //选项卡切换
    handleClick(tab, event) {
      console.log(tab, event);
      this.formInline = {
        dataValue: "",
        keyWord: "",
      };
      if (this.activeName == 0) {
        this.getTeacherList();
      } else if (this.activeName == 1) {
        this.getHistoryTeacherList();
      }
    },
    searcList() {
      this.currentPage = 1;
      this.getTeacherList(this.currentPage);
    },
    //获取列表
    getTeacherList(pageIndex = 1, pageSize = 10) {
      console.log(this.formInline.dataValue);
      var params = {
        Keyword: this.formInline.keyWord,
        DateBegin:
          this.formInline.dataValue == null ? "" : this.formInline.dataValue[0],
        DateEnd:
          this.formInline.dataValue == null ? "" : this.formInline.dataValue[1],
      };
      var url = this.getUrl("&", params);
      console.log(url);
      this.$api
        .get(
          "/admin/AttestationJZG/GetAttestationJZGList?PageIndex=" +
            pageIndex +
            "&PageSize=" +
            pageSize +
            url
        )
        .then((res) => {
          if (res.succeed) {
            this.tableData = res.data.items;
            this.totalCount = res.data.total;
            this.tableData.forEach((element) => {
              element.createTime = element.createTime.substring(0, 10);
            });
            console.log(this.tableData);
            if (this.tableData.length <= 0 && this.currentPage > 1) {
              this.getTeacherList(--this.currentPage);
            }
          } else {
            this.$message.error(res.error);
          }
        });
    },
    searcHistoryList() {
      this.currentPage = 1;
      this.getHistoryTeacherList(this.currentPage);
    },
    //获取历史列表
    getHistoryTeacherList(pageIndex = 1, pageSize = 10) {
      console.log(this.formInline.dataValue);
      var params = {
        Keyword: this.formInline.keyWord,
        DateBegin:
          this.formInline.dataValue == null ? "" : this.formInline.dataValue[0],
        DateEnd:
          this.formInline.dataValue == null ? "" : this.formInline.dataValue[1],
        state: this.formInline.label,
      };
      var url = this.getUrl("&", params);
      console.log(url);
      this.$api
        .get(
          "/admin/AttestationJZG/GetHistoryAttestationJZGList?PageIndex=" +
            pageIndex +
            "&PageSize=" +
            pageSize +
            url
        )
        .then((res) => {
          if (res.succeed) {
            this.tableData = res.data.items;
            this.totalCount = res.data.total;
            this.tableData.forEach((element) => {
              element.createTime = element.createTime.substring(0, 10);
            });
            console.log(this.tableData);
          } else {
            this.$message.error(res.error);
          }
        });
    },
    //获取详情信息
    getTeacherInfo(currId) {
      this.$api
        .get("/admin/AttestationJZG/GetAttestationGLYInfo?id=" + currId)
        .then((res) => {
          if (res.succeed) {
            this.currTeacherInfo = [];
            this.currTeacherInfo.push(res.data);
          } else {
            this.$message.error(res.error);
          }
        });
    },
    //审核
    adjustTeacher(currId, state, cancleReason = "") {
      this.$api
        .post("/admin/AttestationJZG/Audit", {
          ids: currId,
          state: state,
          cancleReason: cancleReason,
        })
        .then((res) => {
          if (res.succeed) {
            this.$message.success("操作成功！");
            this.close();
            this.getTeacherList(this.currentPage, this.currentSize);
          } else {
            this.$message.error(res.error);
          }
        });
    },
    //关闭
    close() {
      this.centerDialogVisible = false;
    },
    //批量审核
    judStudents() {
      if (this.judIds.length <= 0) {
        this.$message.error("请至少选择一条审核信息！");
        return false;
      }
      this.$confirm("确认批量通过审核?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.adjustTeacher(this.judIds, 1);
        })
        .catch(() => {});
    },
    see(val) {
      this.centerDialogVisible = true;
      this.getTeacherInfo(val.id);
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.currentPage = 1;
      this.currentSize = val;
      if (this.activeName == 0) {
        this.getTeacherList(this.currentPage, this.currentSize);
      } else if (this.activeName == 1) {
        this.getHistoryTeacherList(this.currentPage, this.currentSize);
      }
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      if (this.activeName == 0) {
        this.getTeacherList(this.currentPage, this.currentSize);
      } else if (this.activeName == 1) {
        this.getHistoryTeacherList(this.currentPage, this.currentSize);
      }
    },
    //动态获取url
    getUrl(url, queryConfig) {
      //var queryConfig={"page" : "index", "method" : 2}
      var that = this;
      var _str = "";
      for (var obj in queryConfig) {
        if (!that.isNull(queryConfig[obj])) {
          _str += obj + "=" + queryConfig[obj] + "&";
        }
      }
      console.log(_str.length);
      if (_str.length > 0) {
        return url + _str.substring(0, _str.length - 1);
      } else {
        return "";
      }
    },
    //判空方法
    isNull(val = "") {
      if (val == undefined || val == null) {
        return true;
      }
      var str = val.toString().replace(/(^\s*)|(\s*$)/g, ""); //去除空格;
      if (str == "" || str == undefined || str == null) {
        return true;
      }
    },
  },
  components: {
    Faculty,
  },
};
</script>
<style lang="scss" scoped>
.table {
  margin-top: 0.2rem;
  padding: 0.24rem 0.19rem 0.3rem 0.2rem;
  background-color: rgb(255, 255, 255);
  border-radius: 0.05rem;
}
.filter {
  padding: 0.25rem 0.19rem 0.23rem 0.2rem;
  background-color: rgb(255, 255, 255);
  border-radius: 0.05rem;
  display: flex;
  justify-content: space-between;
  >>> .el-form-item {
    margin-bottom: 0;
  }
}
.section {
  padding: 0.23rem 0.18rem 0.57rem;
  flex: 1 1 2.4rem;
  border-radius: 0.06rem;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  height: 1.4rem;
  .name {
    color: rgb(102, 102, 102);
    font-size: 0.18rem;
    font-family: Microsoft YaHei;
    line-height: 0.17rem;
  }
  .number {
    margin-top: 0.17rem;
    color: rgb(51, 51, 51);
    font-size: 0.32rem;
    font-family: Microsoft YaHei;
    line-height: 0.26rem;
  }
}
</style>


// WEBPACK FOOTER //
// src/view/authentication/teacher.vue